import React, { useState } from 'react';
import clsx from 'clsx';
import './index.css';

export default function Index(props: any) {
  const {
    text = '',
    desc = false,
    type = 'primary',
    onClick,
    icon = false,
    fullWidth = false,
    width,
    clickDelay = 500,
    disabled,
  } = props;

  const [block, setBlock] = useState(false);

  const clickDisabled = () => block || disabled;

  const containerWidth = () => {
    if (fullWidth) {
      return {
        width: '100%',
      };
    }
    if (width) {
      return {
        width,
      };
    }
    return {
      flex: 1,
    };
  };

  const clickHandler = () => {
    if (!onClick || typeof onClick !== 'function') return;
    onClick?.();
    setBlock(true);

    setTimeout(() => {
      setBlock(false);
    }, clickDelay);
  };

  const getContainerClass = () => {
    const classList: string[] = [type];

    // todo-why:暂时不会用到PC
    // if (appInfo.isPc) {
    //   classList.push('pc');
    // }

    if (clickDisabled()) {
      classList.push('disabled');
    }
    return classList;
  };

  return (
    <view
      disabled={clickDisabled}
      // todo-why：containerClass 这里要重点验证是否生效
      className={clsx('container', getContainerClass())}
      style={containerWidth()}
      onClick={clickHandler}
      // touchstart={onTouchStart} // todo-why：确认 mach 是否支持，本次没有这个是否可以
    >
      <image className="cs-icon" src="assets://newcustomerservice/cs-icon.png" />
      <view className="title-container">
        <text className="text">{text}</text>
        {desc ? <text className="desc">{desc}</text> : null}
      </view>
    </view>
  );
}
